import gsap from "gsap";

export default function initHome() {
	// ── Desktop menu ──────────────────────────────────
	const toggleBtn = document.querySelector(".see-more__toggle");
	const menu = document.getElementById("see-more-menu");

	// ── Mobile menu ───────────────────────────────────
	const toggleBtnMobile = document.querySelector(".see-more-mobile__toggle");
	const menuMobile = document.getElementById("see-more-menu-mobile");

	// ── Autoplay videos ───────────────────────────────
	if (document.querySelector('video[autoplay]')) {
		document.querySelectorAll('video[autoplay]').forEach((vid) => {
			try {
				vid.currentTime = 0; // rewind
				vid.play().catch(() => {
					console.warn("Autoplay prevented:", vid);
				});
			} catch (e) {
				console.error(e);
			}
		});
	}

	// ── Desktop "See more" menu ───────────────────────
	let isMenuOpen = false;

	if (menu) {
		menu.style.pointerEvents = "none";
		gsap.set(menu, { autoAlpha: 0, y: 50, scale: 0.95 });
	}

	function openMenu() {
		if (!menu) return;
		isMenuOpen = true;
		gsap.killTweensOf(menu);
		if (toggleBtn) toggleBtn.setAttribute("aria-expanded", "true");
		menu.style.pointerEvents = "auto";
		gsap.fromTo(
			menu,
			{ autoAlpha: 0, y: 50, scale: 0.95 },
			{ autoAlpha: 1, y: 0, scale: 1, duration: 0.4, ease: "back.out(1.7)" }
		);
	}

	function closeMenu() {
		if (!menu) return;
		isMenuOpen = false;
		gsap.killTweensOf(menu);
		if (toggleBtn) toggleBtn.setAttribute("aria-expanded", "false");
		menu.style.pointerEvents = "none";
		gsap.to(menu, { autoAlpha: 0, y: -10, scale: 0.95, duration: 0.3, ease: "power2.in" });
	}

	function toggleMenu() {
		isMenuOpen ? closeMenu() : openMenu();
	}

	if (toggleBtn) {
		toggleBtn.addEventListener("click", (e) => {
			e.stopPropagation();
			toggleMenu();
		});
	}

	// ── Mobile "See more" menu ────────────────────────
	let isMenuMobileOpen = false;

	if (menuMobile) {
		menuMobile.style.pointerEvents = "none";
		gsap.set(menuMobile, { autoAlpha: 0, y: 50, scale: 0.95 });
	}

	function openMenuMobile() {
		if (!menuMobile) return;
		isMenuMobileOpen = true;
		gsap.killTweensOf(menuMobile);
		if (toggleBtnMobile) toggleBtnMobile.setAttribute("aria-expanded", "true");
		menuMobile.style.pointerEvents = "auto";
		gsap.fromTo(
			menuMobile,
			{ autoAlpha: 0, y: 50, scale: 0.95 },
			{ autoAlpha: 1, y: 0, scale: 1, duration: 0.4, ease: "back.out(1.7)" }
		);
	}

	function closeMenuMobile() {
		if (!menuMobile) return;
		isMenuMobileOpen = false;
		gsap.killTweensOf(menuMobile);
		if (toggleBtnMobile) toggleBtnMobile.setAttribute("aria-expanded", "false");
		menuMobile.style.pointerEvents = "none";
		gsap.to(menuMobile, { autoAlpha: 0, y: -10, scale: 0.95, duration: 0.3, ease: "power2.in" });
	}

	function toggleMenuMobile() {
		isMenuMobileOpen ? closeMenuMobile() : openMenuMobile();
	}

	if (toggleBtnMobile) {
		toggleBtnMobile.addEventListener("click", (e) => {
			e.stopPropagation();
			toggleMenuMobile();
		});
	}

	// ── Close on outside click ────────────────────────
	document.addEventListener("click", (e) => {
		if (isMenuOpen && menu && toggleBtn &&
			!menu.contains(e.target) && !toggleBtn.contains(e.target)) {
			closeMenu();
		}
		if (isMenuMobileOpen && menuMobile && toggleBtnMobile &&
			!menuMobile.contains(e.target) && !toggleBtnMobile.contains(e.target)) {
			closeMenuMobile();
		}
	});

	// ── Close on Escape ───────────────────────────────
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape" && isMenuOpen) {
			closeMenu();
			if (toggleBtn) toggleBtn.focus();
		}
		if (e.key === "Escape" && isMenuMobileOpen) {
			closeMenuMobile();
			if (toggleBtnMobile) toggleBtnMobile.focus();
		}
	});
}